import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogDescription,
} from '../ui/dialog';
import { useLanguage } from '../../lib/LanguageContext';

export const LegalLinks = () => {
  const { t } = useLanguage();
  return (
    <div className="flex flex-wrap gap-x-6 gap-y-2 text-xs text-cream/60">
      <Dialog>
        <DialogTrigger
          data-testid="privacy-link"
          className="hover:text-cream underline underline-offset-4 decoration-cream/20 hover:decoration-cream/60 transition-colors"
        >
          {t.legal.privacyLink}
        </DialogTrigger>
        <DialogContent className="max-w-2xl bg-cream border-sand-200 text-ink-900">
          <DialogHeader>
            <DialogTitle className="font-serif text-2xl text-ink-900">
              {t.legal.privacyTitle}
            </DialogTitle>
            <DialogDescription className="sr-only">Privacy Policy</DialogDescription>
          </DialogHeader>
          <div className="text-sm text-ink-700 leading-relaxed space-y-4 max-h-[60vh] overflow-y-auto pr-2">
            {t.legal.privacyBody.map((p, i) => <p key={i}>{p}</p>)}
          </div>
        </DialogContent>
      </Dialog>

      <Dialog>
        <DialogTrigger
          data-testid="terms-link"
          className="hover:text-cream underline underline-offset-4 decoration-cream/20 hover:decoration-cream/60 transition-colors"
        >
          {t.legal.termsLink}
        </DialogTrigger>
        <DialogContent className="max-w-2xl bg-cream border-sand-200 text-ink-900">
          <DialogHeader>
            <DialogTitle className="font-serif text-2xl text-ink-900">
              {t.legal.termsTitle}
            </DialogTitle>
            <DialogDescription className="sr-only">Terms and Conditions</DialogDescription>
          </DialogHeader>
          <div className="text-sm text-ink-700 leading-relaxed space-y-4 max-h-[60vh] overflow-y-auto pr-2">
            {t.legal.termsBody.map((p, i) => <p key={i}>{p}</p>)}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default LegalLinks;
